import React from 'react'
import R from 'ramda'
import {Marker, Popup} from 'react-leaflet'
import {divIcon} from 'leaflet'
import {connect} from 'react-redux'

import updatePoiAddress from '../actions/updatePoiAddress'

const poiIcon = (markerCount) => {

    var markerSrc = '/images/marker/marker-poi-default.png';

    return divIcon({
    iconSize:[57,61],
    iconAnchor: [29,57],
    html: `
        <span class="poi-marker-container"><img src="${markerSrc}"/><span class="markercount">${markerCount}</span></span>
    `
  });
}

class PoiMarker extends React.Component {
  shouldComponentUpdate(nextProps){
    return !R.equals(nextProps, this.props)
  } 
  render(){
      
    const {poi, onDragEnd} = this.props

    return <Marker icon={poiIcon(poi.markerCount)} position={poi.coordinates} draggable={true} onDragEnd={(event) => onDragEnd(poi.markerCount, event.target._latlng)} zIndexOffset={4}>
             <Popup>
             <span>{poi.description}</span>
             </Popup>
           </Marker>
  }
}

PoiMarker.propTypes = {
  poi: React.PropTypes.shape({
    markerCount: React.PropTypes.string.isRequired,
    description: React.PropTypes.string.isRequired,
    coordinates: React.PropTypes.shape({
      lat: React.PropTypes.number.isRequired,
      lng: React.PropTypes.number.isRequired
    }).isRequired,
  }).isRequired,
  onDragEnd: React.PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => ({
  onDragEnd: (poiMarkerCount, latlng) => {
    dispatch(updatePoiAddress(poiMarkerCount, latlng))
  }  
})

export default connect(null, mapDispatchToProps)(PoiMarker)



/** WEBPACK FOOTER **
 ** ./app/components/PoiMarker.jsx
 **/